import React from 'react'
import * as medias from '@/consts/medias'

import { Box, useMediaQuery } from '@material-ui/core'
import { Print } from '@material-ui/icons'

import Dialog from '@/components/Dialog'

import { StyledButton } from './styles'

import { CollectPrintCards } from './CollectPrintCards'
import { CollectPrintHeader } from './CollectPrintHeader'
import { CollectPrintTable } from './CollectPrintTable'

// ----------------------------------------------------

export function CollectPrint({ collect, ...props }) {
  const sm = useMediaQuery(medias.sm)

  function handlePrint() {
    window.print()
  }

  return (
    <Dialog
      {...props}
      fullWidth
      fullScreen={sm}
      maxWidth="lg"
      title={`Impressão Coleta ${collect.id}`}
      className="printable"
      actions={
        <>
          <StyledButton
            color="primary"
            label="Fechar"
            variant="contained"
            onClick={props.onClose}
          />
          <StyledButton
            color="primary"
            startIcon={<Print />}
            label="Imprimir"
            variant="outlined"
            onClick={handlePrint}
          />
        </>
      }
    >
      <Box
        display="flex"
        flexDirection="column"
        gridGap="1rem"
        marginTop="1rem"
        marginBottom="1rem"
      >
        {/* === HEADER ===  */}
        <CollectPrintHeader data={collect} />

        {/* === CARDS ===  */}
        <CollectPrintCards data={collect} />

        {/* === TABLE ===  */}
        <CollectPrintTable data={collect.items} />
      </Box>
    </Dialog>
  )
}

export default CollectPrint
